<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 md8 lg6>
        <barcode :backgroundColor="backgroundColor" title="SKU Check" subtitle="Scan or Enter a Value"
          buttonText="Search" @search="searchProducts" ref="barcodeComponent" />
      </v-flex>


    </v-layout>
    <v-layout justify-center class="mt-4">
      <v-flex xs12 md8 lg6> 
        <v-card :color="backgroundColor" :style="{ width: '100%', margin: 'auto' }">
          <v-data-table flat :headers="headers" class="mx-2" :items="scannedProducts"
            :total-items="scannedProducts.length" :pagination.sync="pagination">
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.upc }}</td>
              <td class="text-xs-left">
                {{ props.item.sku }}
              </td>
              <td class="text-xs-left">
                {{ props.item.rtv ? "Yes" : "No" }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Barcode from "@/components/app/Barcode";

export default {
  name: "sku-check",
  data() {
    return {

      backgroundColor: "primary",
      headers: [
        { text: "UPC", value: "upc" },
        { text: "SKU", value: "sku" },
        { text: "RTV", value: "rtv" }
      ],

      scannedProducts: []
    };
  },

  components: {
    Barcode
  },

  mixins: [LoginCheck],

  computed: {
    ...mapGetters({
      products: "product/getProduct"
    })
  },

  methods: {
    ...mapActions({
      productSearch: "product/searchOdoo"
    }),

    async searchProducts(barcodeValue) {
      this.backgroundColor = "primary";
      await this.productSearch([
        {
          field: "x_upc",
          operator: "=",
          value: barcodeValue.trim(),
        }
      ]);
      if (this.products.length == 0) {
        this.scannedProducts.push({
          upc: barcodeValue,
          sku: "NOT FOUND IN ODOO",
          rtv: false
        });
      } else if (this.products.length == 1) {
        let isRtv = this.products[0].default_code.toLowerCase().endsWith("rtv");
        if (isRtv) this.backgroundColor = "#8CB369";
        else this.backgroundColor = "#B32424";
        this.scannedProducts.push({
          upc: barcodeValue,
          sku: this.products[0].default_code,
          rtv: isRtv
        });
      } else {
        let isRtv = this.products.filter(p => p.default_code.toLowerCase().endsWith("rtv")).length > 0;
        if (isRtv) this.backgroundColor = "#8CB369";
        else this.backgroundColor = "#B32424";
        this.scannedProducts.push({
          upc: barcodeValue,
          sku: this.products[0].default_code,
          rtv: isRtv
        });
      }
      this.$refs.barcodeComponent.focusBarcode();
    }
  }
};
</script>

<style></style>